import React from "react";
import BannerPerson from "../../../assets/Images/BannerPerson.png";
import { Stack, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import "../../../App.css";

const SecondaryBanner = () => {
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: "300px",
          backgroundColor: "#0741C4",
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          style={{ width: "90%", margin: "auto", height: "100%" }}
        >
          <div style={{ width: "100%" }}>
            <Typography
              variant="h3"
              component="h1"
              color="white"
              style={{
                fontWeight: "700",
                fontSize: "20px",
                lineHeight: "29px",
                textAlign: "center",
              }}
            >
              Find a local and reliable handyman in few clicks!
            </Typography>
            <Typography
              variant="subtitle1"
              color="black"
              style={{ textAlign: "center", color: "white" }}
            >
              Post your request by filling simple requirement and get quotes
              from experts within few minutes.
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              justifyContent="center"
              className="mt-6"
            >
              <Link to="/choose-flow" state={{ flow: "register" }}>
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    backgroundColor: "white",
                    color: "rgba(7, 65, 196, 1)",
                  }}
                >
                  Become Partner
                </Button>
              </Link>
            </Stack>
          </div>
        </Stack>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "400px",
          backgroundColor: "#0741C4",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ width: "90%", margin: "auto" }}
        >
          <div
            style={{
              width: "40%",
              height: "400px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              color="white"
              style={{
                fontWeight: "700",
                fontSize: "48px",
                lineHeight: "56px",
                marginBottom: "24px",
              }}
            >
              Earn money with your skills and expertise
            </Typography>
            <Typography
              variant="subtitle1"
              color="white"
              style={{ marginBottom: "24px" }}
            >
              Register as a partner and start earning money by completing the
              jobs requested.
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              className="mt-6"
            >
              <Link to="/choose-flow" state={{ flow: "register" }}>
                <Button
                  variant="contained"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    backgroundColor: "white",
                    color: "rgba(7, 65, 196, 1)",
                    padding: "12px 16px",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  Become Member
                </Button>
              </Link>
            </Stack>
          </div>
          <div style={{ width: "35%" }}>
            <img
              src={BannerPerson}
              alt="Banner Person"
              style={{
                height: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
              }}
            />
          </div>
        </Stack>
      </div>
    );
  }
};

export default SecondaryBanner;
